import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Subscription } from "../../types/plans";
import { PaymentSuccess } from "./PaymentSuccess";

export default function PaymentSuccessPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const selectedPlan = location.state?.selectedPlan as Subscription;

  useEffect(() => {
    if (!selectedPlan) {
      navigate("/Pricing");
    }
  }, [selectedPlan, navigate]);

  if (!selectedPlan) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center pt-[120px] px-3 pb-2.5 md:pb-0">
      <div className="max-w-xl">
        <PaymentSuccess selectedPlan={selectedPlan} />
      </div>
    </div>
  );
}
